export { default as badgesSet } from './badgesSet';


// WEBPACK FOOTER //
// ./src/containers/elements/Badges/constants/index.js